import { FormattedMessage } from "react-intl";
import { Button } from "@/components/design/Button";
import { ORGANIZATIONAL_RECORD_ANCHOR } from "./use-organizational-record-section";

/** The one button that opens the organisational record under a page; the caller decides who sees it. */
export function OrganizationalRecordToggle({ expanded, onOpen }: { expanded: boolean; onOpen: () => void }) {
  return <Button id="organizational-record-open" variant="secondary" size="compact" aria-expanded={expanded} aria-controls={ORGANIZATIONAL_RECORD_ANCHOR} onClick={onOpen}>
    <FormattedMessage id="organizationalRecord.heading" />
  </Button>;
}
